module.exports = __webpack_public_path__ + "static/media/Image-Values1.19b0fa3a.png";